import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EntiteUtilisateurModel } from 'src/models/selectionEntiteUtilisateurModel';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { SelectionEntiteCardComponent } from './selection-entite-card/selection-entite-card.component';
import { TranslateModule } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';
import { StatePersistenceService } from 'src/services/state-persistence.service';

@Component({
    selector: 'app-selection-entite',
    templateUrl: './selection-entite.component.html',
    styleUrls: ['./selection-entite.component.scss'],
    imports: [SelectionEntiteCardComponent, TranslateModule, MatIcon]
})
export class SelectionEntiteComponent implements OnInit {
  entiteUtilisateurs: EntiteUtilisateurModel[] = [];
  constructor(
    public utilisateurService: UtilisateurService,
    private router: Router,
    private statePersistenceService: StatePersistenceService
  ) { }

  ngOnInit(): void {
    this.statePersistenceService.clearAllStates();
    this.utilisateurService.entiteUtilisateurSelectionnee = undefined!;

    this.utilisateurService.selectionEntiteUtilisateur.entiteUtilisateurs.forEach(element => {
      if (element.roleEntites.some(r => r.roleId === 1)) {
        this.entiteUtilisateurs.push(element);
      }
    });

    this.utilisateurService.selectionEntiteUtilisateur.entiteUtilisateurs.forEach(element => {
      if (element.roleEntites.some(r => r.roleId === 2)) {
        this.entiteUtilisateurs.push(element);
      }
    });

    this.utilisateurService.selectionEntiteUtilisateur.entiteUtilisateurs.forEach(element => {
      if (element.roleEntites.length === 0) {
        this.entiteUtilisateurs.push(element);
      }
    });
  }

  onCardClick(entiteUtilisateur: EntiteUtilisateurModel) {
    const oldEntityId = this.utilisateurService.entiteUtilisateurSelectionnee?.entiteId;

    if (oldEntityId && oldEntityId !== entiteUtilisateur.entiteId) {
      this.statePersistenceService.clearAllStates();
    }

    this.utilisateurService.entiteUtilisateurSelectionnee = entiteUtilisateur;

    const redirectUrl = sessionStorage.getItem('redirectUrl');
    sessionStorage.removeItem('redirectUrl');

    if (redirectUrl) {
      this.router.navigateByUrl(redirectUrl);
    } else {
      this.router.navigate(['accueil']);
    }
  }
}
